var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-animate-skeleton-loader gl-mt-2 gl-h-4 gl-w-full gl-rounded-default"})
}
var staticRenderFns = []

export { render, staticRenderFns }